import { useMemo } from "react";
import {
  getMessageSettingRCS,
  getMessageSettings,
} from "../../../utils/helpers";

export function useCountChars(message, isRCS = true) {
  const { count, maxCharacters, messages, type } = useMemo(() => {
    let settings = getMessageSettingRCS(message);
    if (!isRCS) {
      settings = getMessageSettings(message);
    }

    const Resolver = new TextEncoder();

    const length = message ? Resolver.encode(message).length : 0;

    return {
      count: length,
      maxCharacters: settings.limit,
      messages: length ? Math.ceil(length / settings.limit) : 0,
      type: settings.type,
    };
  }, [message]);

  return { count, maxCharacters, messages, type };
}
